// extracted by mini-css-extract-plugin
export default {"custom-scrollbar":"mainStyle_custom-scrollbar__gaXPW"};